<template>
  <div class="border-2 border-amber-200 bg-amber-50 p-4 shadow-md">
    <p v-if="heading" class="mb-1.5 text-sm font-semibold text-amber-900">
      {{ heading }}
    </p>
    <p class="text-sm font-bold leading-snug text-amber-800">
      {{ formattedLastDataSentAt }}
      <span class="font-semibold">({{ lastDataAgeLabel }})</span>
    </p>
    <p class="mt-2 text-xs font-normal leading-relaxed text-amber-700">
      Os valores exibidos refletem a última transmissão e podem não representar o instante exato atual.
    </p>
    <p v-if="pollingError" class="mt-2 text-sm font-medium text-red-700">{{ pollingError }}</p>

    <div class="my-4 border-t border-dashed border-amber-400" />

    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-start gap-2 text-sm font-medium text-amber-900">
        <InformationCircleIcon class="mt-0.5 h-5 w-5 shrink-0 text-amber-700" aria-hidden="true" />
        <span>Ajuste o intervalo de leitura</span>
      </div>
      <div class="flex shrink-0 items-center gap-2 sm:ml-auto">
        <label class="text-sm font-medium text-amber-900" for="last-communication-polling-interval">Período</label>
        <select
          id="last-communication-polling-interval"
          :value="pollingIntervalSeconds"
          class="min-w-[5.5rem] border border-amber-300 bg-white px-3 py-1.5 pr-8 text-sm text-amber-900"
          @change="onIntervalChange">
          <option
            v-for="seconds in pollingIntervalOptions"
            :key="seconds"
            :value="seconds">
            {{ seconds }}s
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/24/outline'

withDefaults(
  defineProps<{
    heading?: string
    formattedLastDataSentAt: string
    lastDataAgeLabel: string
    pollingIntervalSeconds: number
    pollingIntervalOptions: number[]
    pollingError?: string | null
  }>(),
  {
    heading: '',
    pollingError: null,
  },
)

const emit = defineEmits<{
  'update:pollingIntervalSeconds': [value: number]
}>()

function onIntervalChange(e: Event) {
  const el = e.target as HTMLSelectElement
  const n = Number(el.value)
  if (!Number.isNaN(n)) emit('update:pollingIntervalSeconds', n)
}
</script>
